import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, PropType, ref, shallowRef } from 'vue'
import { IAsrApi } from '@/api/asr/type'
import { getAsrDomainOptionsApi } from '@/api/asr'


export default /*#__PURE__*/_defineComponent({
  __name: 'CommonFormItems',
  props: {
  lang: {
    type: String as PropType<'cn' | 'eng'>,
    default: 'cn'
  },
  type: {
    type: Number as PropType<1 | 2>,
    required: true
  },
  property: {
    type: String,
  },
  hiddenRadioList: {
    type: Boolean
  }
},
  emits: ['update-lang', 'update-property'],
  setup(__props, { expose, emit: emits }) {

const props = __props





const langOptions = [
  { label: '中文普通话', value: 'cn' },
  { label: '英文', value: 'eng' },
]
// 缓存domain结果
const cacheDomainOptions: {
  cn: IAsrApi.IDomainOption[]
  eng: IAsrApi.IDomainOption[]
} = {
  cn: [],
  eng: []
}
const domainOptions = shallowRef<IAsrApi.IDomainOption[]>([])

const selectedDomain = computed(() => domainOptions.value[domainIdx.value])

const domainOptionsLoading = ref(false)
function getDomainOptions(lang: 'cn' | 'eng') {
  const targetCacheDomainOptions = cacheDomainOptions[lang]
  console.log('targetCacheDomainOptions: ', targetCacheDomainOptions)
  if(targetCacheDomainOptions && targetCacheDomainOptions.length > 0) {
    handleDomainOptions(targetCacheDomainOptions)
  } else {
    domainOptionsLoading.value = true
    getAsrDomainOptionsApi(lang, props.type).then(({ data }) => {
      const result = (data ?? []).filter(item => !['恋爱心理情绪', '恋爱心里情绪'].includes(item.name))
      cacheDomainOptions[lang] = result
      handleDomainOptions(result)
    }).finally(() => {
      domainOptionsLoading.value = false
    })
  }
}
function handleDomainOptions(data: IAsrApi.IDomainOption[]) {
  // FIXME: 后端暂时返回的 null
  // 产品需求先去掉 恋爱心理情绪 这个领域
  domainOptions.value = data ?? []
  // 默认选择第1个
  console.log('props.property: ', props.property)
  if (!props.property && domainOptions.value.length) {
    domainIdx.value = 0
    emits('update-property', domainOptions.value[domainIdx.value].property)
  } else {
    domainIdx.value = domainOptions.value.findIndex(i => i.property == props.property)
  }
}

getDomainOptions(props.lang)

async function onLangChange(e: 'cn' | 'eng') {
  emits('update-lang', e)
  emits('update-property')
  await nextTick()
  getDomainOptions(e)
}

const domainIdx = ref(domainOptions.value.findIndex(i => i.property == props.property))
function onDomainChange(e: number) {
  domainIdx.value = e
  emits('update-property', domainOptions.value[e]?.property)
}
expose({
  onLangChange
})


return { __sfc: true,props, emits, langOptions, cacheDomainOptions, domainOptions, selectedDomain, domainOptionsLoading, getDomainOptions, handleDomainOptions, onLangChange, domainIdx, onDomainChange }
}

})